import { get, post, put, del } from '../../apiClient';
import { API_ENDPOINTS } from '../../config';

const qualificationCriteriaService = {
  /**
   * Create new qualification criteria
   */
  createQualificationCriteria: async (criteriaData) => {
    try {
      const response = await post(API_ENDPOINTS.CRM.QUALIFICATION_CRITERIA, criteriaData);

      if (response && response.responseCode === 201) {
        return {
          success: true,
          criteria: response.data
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to create qualification criteria'
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to create qualification criteria'
      };
    }
  },

  /**
   * Get all qualification criteria
   */
  getAllQualificationCriteria: async (filters = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (filters.isActive !== undefined) queryParams.append('isActive', filters.isActive);
      if (filters.search !== undefined) queryParams.append('search', filters.search);

      const url = queryParams.toString()
        ? `${API_ENDPOINTS.CRM.QUALIFICATION_CRITERIA}?${queryParams.toString()}`
        : API_ENDPOINTS.CRM.QUALIFICATION_CRITERIA;

      const response = await get(url);

      if (response && response.responseCode === 200) {
        return {
          success: true,
          criteria: response.data || []
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to retrieve qualification criteria',
          criteria: []
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to retrieve qualification criteria',
        criteria: []
      };
    }
  },

  /**
   * Get qualification criteria by ID
   */
  getQualificationCriteriaById: async (criteriaId) => {
    try {
      const response = await get(`${API_ENDPOINTS.CRM.QUALIFICATION_CRITERIA}/${criteriaId}`);

      if (response && response.responseCode === 200) {
        return {
          success: true,
          criteria: response.data
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to retrieve qualification criteria'
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to retrieve qualification criteria'
      };
    }
  },

  /**
   * Update qualification criteria
   */
  updateQualificationCriteria: async (criteriaId, criteriaData) => {
    try {
      const response = await put(`${API_ENDPOINTS.CRM.QUALIFICATION_CRITERIA}/${criteriaId}`, criteriaData);

      if (response && response.responseCode === 200) {
        return {
          success: true,
          criteria: response.data,
          message: response.responseMessage || 'Qualification criteria updated successfully'
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to update qualification criteria'
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to update qualification criteria'
      };
    }
  },

  /**
   * Delete qualification criteria
   */
  deleteQualificationCriteria: async (criteriaId) => {
    try {
      const response = await del(`${API_ENDPOINTS.CRM.QUALIFICATION_CRITERIA}/${criteriaId}`);

      if (response && response.responseCode === 200) {
        return {
          success: true,
          message: response.responseMessage || 'Qualification criteria deleted successfully'
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to delete qualification criteria'
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to delete qualification criteria'
      };
    }
  },

  /**
   * Export qualification criteria
   */
  exportQualificationCriteria: async (filters = {}) => {
    try {
      const queryParams = new URLSearchParams(filters);
      // API_ENDPOINTS.CRM.QUALIFICATION_CRITERIA contains the full URL
      const url = `${API_ENDPOINTS.CRM.QUALIFICATION_CRITERIA}/export?${queryParams.toString()}`;

      const token = localStorage.getItem('auth_token');
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const blob = await response.blob();
        return {
          success: true,
          data: blob
        };
      }

      return {
        success: false,
        error: 'Failed to export qualification criteria'
      };

    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to export qualification criteria'
      };
    }
  }
};

export default qualificationCriteriaService;

